import QuizSelectorForm from "../components/QuizSelectorForm";

function QuizListPage() {
  return <QuizSelectorForm />;
}

export default QuizListPage;
